

import React from 'react';
import moment from 'moment';

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const IndustryRecentCauses = (props) => {
  const { data, companyType } = props;
  return (
    <div>
      <section className="trending-causes bg-gray campaignSec2 school-sec-5">
        <div className="container">
          <h3 className="main-heading text-center sm-title">Help them for hapiness!</h3>
          <h2 className="main-heading text-center bg-title">Recent Causes</h2>
          {
            data && data.length ?
              <OwlCarousel className="owl-carousel owl-theme campaignTrendingCards" margin={15} dots={true} responsive={{ 0: { items: 1 }, 525: { items: 2 }, 820: { items: 3 } }} nav={false}>
                {
                  data && data.map(({ id, story, cover_photo: coverPhoto, address, end_date, deadline, title, progress, amount }, index) => {
                    const daysGone = deadline ? `${Math.abs(moment(deadline).diff(moment(), 'days'))} days left` : 'N/A';
                    const formattedAddress = address ? (address.length >= 35 ? `${address.substring(0, 30)}...` : address) : 'N/A';
                    const formattedStory = story ? (story.length >= 40 ? `${story.substring(0, 40)}...` : story) : 'N/A';
                    const formattedTitle = title ? (title.length >= 25 ? `${title.substring(0, 23)}...` : title) : 'N/A';
                    let cover = '/images/school-recent-3.jpg';
                    if (coverPhoto) {
                      cover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${coverPhoto}`;
                    }

                    return <div key={index} className="card trending-cause-card">
                      <div className="img">
                        <img src={cover} className="img-fluid" alt="" />
                        <a href={`/${companyType.toLowerCase()}-donate/${id}`} style={{ textAlign: 'center', paddingTop: 14 }} className="donate-btn">DONATE NOW</a>
                      </div>
                      <div className="desc">
                        <div className="text-card"> <span>{formattedAddress}</span> <span>{daysGone}</span> </div>
                        <a style={{ color: 'black' }} href={`/${companyType.toLowerCase()}-details/${id}`}>
                          <h1>{formattedTitle}</h1>
                          <p>{formattedStory}</p>
                          <div className="text-card m-0"> <span>Last donation</span> <span>{end_date ? moment(end_date).fromNow() : ''}</span> </div>
                          <div className="progres">
                            <div className="progress-inner">
                              <div className="progress-bar" role="progressbar" style={{ width: `${progress || 0}%` }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <div className="treanding-cause-bottom">
                              <h4 className="left-text-s">${amount || 0}<span className="">raised</span></h4>
                              <h4 className="left-right-s">{progress || 0}%</h4>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  })
                }
              </OwlCarousel> : ''
          }
        </div>
      </section>
    </div>
  );
};

export default IndustryRecentCauses;
